<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count= 'count'
      :current="page"
      :showEmptyLine="true"
    >
      <!-- <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>客户:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.nameMix"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单号:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.batchSeq"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div> -->

      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import toolsService from '../../../services/lgq/services';

export default {
  name: 'drugManageList',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: { },
      columns: [
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批准文号', key: 'approvalCode', minWidth: 116 },
        { title: '剂型', key: 'dosageForm', minWidth: 116 },
        { title: '最小包装单位', key: 'minPkgUnit', minWidth: 116 },
        { title: '存储条件', key: 'storageCondition', minWidth: 116 },
        { title: '销售单价', key: 'salePrice', minWidth: 116 },
        {
          title: '销量税率',
          key: 'outputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', `${params.row.outputTaxRate}%`),
        }],
      tableData: [],
    };
  },
  methods: {
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      toolsService.drugList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {};
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
  },
};
</script>

<style scoped>
</style>
